<template>
  <span>
    <base-icon
      v-if="status === `pending`"
      icon="spinner-btn"
      class="animate-spin w-5 h-5 text-lg"
    />
    <base-icon v-if="status === `error`" icon="cancel" class="text-red-default text-lg" />
    <base-icon v-if="status === `success`" icon="success" class="text-green-dark text-lg" />
    <span v-if="status === undefined">-</span>
  </span>
</template>

<script>
import {BaseIcon} from '@/components/base'
export default {
  components: {
    BaseIcon,
  },
  props: {
    status: String,
    required: true,
  },
}
</script>
